import React, { useState, useEffect } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import PopularLocationItem from '../PopularLocationItem';
import Loader from '../../Loader/Loader';
import { isRTL } from '../../../helpers/formatLocale';
import { dynamicLocationValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

import cs from 'swiper/swiper-bundle.css';
import t from '../../../styles/customSwiper.css'
import s from './PopularLocationSlider.css';


const SampleNextArrow = ({ className }) => (
  <div className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" width="10.389" height="18.171" viewBox="0 0 10.389 18.171">
      <path id="Path_42316" data-name="Path 42316" d="M9.3,23.166a1.3,1.3,0,0,1-.921-2.219l6.877-6.864L8.378,7.22a1.3,1.3,0,1,1,1.843-1.842l7.785,7.785a1.3,1.3,0,0,1,0,1.829l-7.785,7.785a1.3,1.3,0,0,1-.921.389Z" transform="translate(-7.994 -4.996)" fill='currentColor' />
    </svg>
  </div>
);

const SamplePrevArrow = ({ className }) => (
  <div className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" width="10.389" height="18.17" viewBox="0 0 10.389 18.17">
      <path id="Path_42317" data-name="Path 42317" d="M17.078,23.166A1.3,1.3,0,0,0,18,20.948l-6.877-6.864L18,7.22a1.3,1.3,0,0,0-1.842-1.842L8.371,13.163a1.3,1.3,0,0,0,0,1.829l7.785,7.785a1.3,1.3,0,0,0,.921.389Z" transform="translate(-7.994 -4.996)" fill='currentColor' />
    </svg>
  </div>
);


function PopularLocationSlideComponent({ data = [], intl }) {
  const [swiperPackage, setSwiperPackage] = useState(null);
  const [swiperModule, setSwiperModule] = useState(null);
  const [isReady, setIsReady] = useState(false);

  const { locale } = intl;
  const rtl = isRTL(locale);

  useEffect(() => {
    const loadSwiper = async () => {
      const pkg = await import('swiper/react');
      const pkgModule = await import('swiper/modules');
      setSwiperPackage(pkg);
      setSwiperModule(pkgModule);
      setIsReady(true);
    };
    loadSwiper();
  }, []);

  if (!swiperPackage) return null;

  const { Swiper, SwiperSlide } = swiperPackage;
  const { Navigation } = swiperModule;
  const enabledSlides = data.filter(item => item.isEnable === 'true').length;

  const params = {
    loop: enabledSlides >= 12,
    modules: [Navigation],
    navigation: {
      nextEl: `.popularLocationSwiperNavigationNextBtn`,
      prevEl: `.popularLocationSwiperNavigationPrevBtn`,
    },
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      // when window width is >= 576px
      576: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 3,
        spaceBetween: 15
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 4,
        spaceBetween: 24
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 5,
        spaceBetween: 24
      },
      // when window width is >= 1300px
      1300: {
        slidesPerView: 6,
        spaceBetween: 24
      }
    }
  }

  return (
    <div>
      {!isReady ? (
        <Loader type="text" />
      ) : (
        <div className={s.positionRelative}>
          <Swiper
            {...params}
            key={rtl} // force remount on language change
            dir={rtl ? 'rtl' : 'ltr'}
          >
            {data.map((item, index) => {
              const { location } = dynamicLocationValue(item, locale);
              return item.isEnable === 'true' ? (
                <SwiperSlide key={index}>
                  <div>
                    <PopularLocationItem
                      id={item.id}
                      location={location}
                      image={item.image}
                      locationAddress={item?.locationAddress}
                    />
                  </div>
                </SwiperSlide>
              ) : null
            })}
          </Swiper>
          <div className="homeSwiperArrowContainer">
            <SamplePrevArrow className={cx('commonSwiperNavigationBtn popularLocationSwiperNavigationPrevBtn')} />
            <SampleNextArrow className={cx('commonSwiperNavigationBtn popularLocationSwiperNavigationNextBtn')} />
          </div>
        </div>
      )}
    </div>
  );
}

export default injectIntl(withStyles(cs, t, s)(PopularLocationSlideComponent));
